<template>
  <div>
    <Button icon="pi pi-trash" @click="deleteSymbol" size="small" class="me-2" severity="secondary" rounded></Button>
    <Button as="a" icon="pi pi-eye" size="small" severity="secondary" rounded
      :href="router.resolve(routerParams).fullPath" target="_blank">
    </Button>
  </div>
</template>

<script lang="ts" setup>
import type { FavSymbolResponse } from '@/services/fav-symbols-v2-service/types';
import Button from "primevue/button"
import { useRouter } from 'vue-router'
import { ref } from "vue"
import { useFavSymbolsStore } from '@/stores/favSymbolsStore';

const router = useRouter()
const favSymbolsStore = useFavSymbolsStore()
const props = defineProps<{
  data: FavSymbolResponse
}>()

const deleteSymbol = async () => {
  favSymbolsStore.symbols = favSymbolsStore.symbols.filter(x => x['id'] !== props.data.id)
  await favSymbolsStore.deleteSymbol(props.data.id)
}

const routerParams = ref({
  name: "eye",
  params: {
    asset: props.data?.asset ?? 'BNB',
    exBuy: props.data?.ex_buy?.name ?? 'gate',
    exSell: props.data?.ex_sell?.name ?? 'mexc',
    marketType: props.data?.market_type ?? 'swap'
  }
})

</script>
